module.exports = __webpack_public_path__ + "img/download-on-the-app-store-no.fb752197.svg";